/**
 * Authentication Route Guard
 * Componente guard che verifica l'autenticazione prima di permettere l'accesso alle rotte protette
 */
import { Navigate } from "react-router";
import { useMe } from "@/hooks/api/use-auth";

interface AuthRouteGuardProps {
    children: React.ReactNode;
}

/**
 * Route Guard che verifica se l'utente è autenticato
 * Se non autenticato, reindirizza alla pagina di login
 */
export function AuthRouteGuard({ children }: AuthRouteGuardProps) {
    const { data: currentUser, isLoading } = useMe();

    // Mostra loading mentre verifica autenticazione
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                    <p className="mt-4 text-sm text-tertiary">Caricamento...</p>
                </div>
            </div>
        );
    }
    
    // Se non autenticato, reindirizza al login
    if (!currentUser) {
        return <Navigate to="/auth/login" replace />;
    }
    
    // Utente autenticato, mostra i children
    return <>{children}</>;
}

